module.exports = __webpack_public_path__ + "static/media/mbs_2.c6db2d64.jpg";